<template>
    <item-list-and-component
            :value="value"
            label=""
            :label-property="labelProperty"
            component="ComponentWrapperWithAddButton"
            :component-props="componentProps"
            v-on:input="$emit('input', $event)"
    ></item-list-and-component>

</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            value: {type: Array},
            urls: {type: Object},
            labelProperty: {type: String, default: 'name'}
        },
        provide: function() {
            return {
                //mainButtons: this.mainButtons
            }
        },
        data: function () {
            return {
                // mainButtons: {
                //     save_and_close: {class: this.getCSSClass('tag-picker-save-button'), html: this.translate('Mentés')},
                //     proceed: {class: this.getCSSClass('tag-picker-save-button'), html: this.translate('Mentés')},
                //     cancel: {class: this.getCSSClass('tag-picker-save-button'), html: this.translate('Mégse')}
                // }
            }
        },
        mounted() {
        },
        methods: {},
        computed: {
            componentProps: function() {
                return {
                    subComponent: 'SearchableSelect',
                    subComponentValuesetProp: 'valueset',
                    formUrl: this.urls.formUrl,
                    storeUrl: this.urls.storeUrl,
                    updateUrl: this.urls.updateUrl ?? null,
                    editUrl: this.urls.editUrl ?? null,
                    fetchUrl: this.urls.fetchUrl,
                    addButtonHTML: this.icon('plus')+this.translate('Hozzáadás'),
                    defaultSubComponentProps: {
                        multiple: false,
                        respectDisabledAttribute: true,
                        buttons: this.mainButtons,
                        labelProperty: this.labelProperty,
                        revertXOpening: false,
                    }
                }
            }
        },
        watch: {}

    }
</script>
